
<div id="seite">
    <div class="impressumBox">
        <div id="navlista">
            <h1 style="color:white;">Legal Disclosure </h1>
            <h2 style="margin: 1rem 0">Contact Information</h2>
            Stefan Starflinger <br>
            Austellungsstraße 50<br>1020 Wien<br>
            Austria
            <br>
            <br>
            Telephone: +4369910847221<br>E-Mail: <a href="mailto:stefan@starflinger.eu">stefan@starflinger.eu</a><br>Internet address: <a href="https://www.starflinger.eu/" target="_blank">https://www.starflinger.eu/</a><br>
            <br>
            <h2 style="margin: 1rem 0">Disclaimer</h2>
            Accountability for content<br>
            The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents'
            accuracy, completeness or topicality. According to statutory provisions, we are furthermore responsible for
            our own content on these web pages. In this matter, please note that we are not obliged to monitor
            the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity.
            Our obligations to remove or block the use of information under generally applicable laws remain unaffected by this as per
            §§ 8 to 10 of the Telemedia Act (TMG).

            <br><br><h2 style="margin: 1rem 0">Accountability for links</h2>
            Responsibility for the content of
            external links (to web pages of third parties) lies solely with the operators of the linked pages. No violations were
            evident to us at the time of linking. Should any legal infringement become known to us, we will remove the respective
            link immediately.
            
            <br><br><h2 style="margin: 1rem 0">Copyright</h2> Our web pages and their contents are subject to German copyright law. Unless
            expressly permitted by law, every form of utilizing, reproducing or processing
            works subject to copyright protection on our web pages requires the prior consent of the respective owner of the rights.
            Individual reproductions of a work are only allowed for private use.
            The materials from these pages are copyrighted and any unauthorized use may violate copyright laws.

            <br><br>
            <i>Quelle: </i><a href="http://www.translate-24h.de" target="_blank">translate-24h.de - Das Übersetzungsbüro im Internet</a> <br><br>
        </div>
    </div>
  </div>


